import React from "react";
import "./header.css";

export default function Header() {
  return (
    <header className="hero" style={{ backgroundImage: `url(${'./images/Pyramid.png'})` }}>
      <div className="overlay">
        <div className="hero-content">
          {/* <h1 className="hero-title">PYRAMID</h1> */}
          <h2 className="hero-subtitle">
            Specialized Solutions in Industrial Coatings, Waterproofing & Flooring
          </h2>
          <a href="#about" className="hero-btn">KNOW MORE</a>
        </div>

        {/* Pyramid graphic (optional) */}
        <div className="hero-pyramid">
          <div className="pyramid-layer layer1">Heat Protection</div>
          <div className="pyramid-layer layer2">Energy Savings</div>
          <div className="pyramid-layer layer3">Eco Friendly</div>
          <div className="pyramid-layer layer4">Durable & Stylish</div>
        </div>
      </div>
    </header>
  );
}
